import React, { useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { ButtonComponent } from './elements';
import Swal from 'sweetalert2';
import { crearSolicitudCupo, getGira } from '../api/giras.ts';

export default function SolicitudCupoModal({ show, onHide, giraId, onSuccess }) {
  const [formData, setFormData] = useState({
    alumno_nombres: '',
    alumno_apellidos: '',
    alumno_rut: '',
    alumno_dv: '',
    alumno_nacionalidad: '',
    alumno_fecha_nacimiento: '',
    alumno_calidad: 'Alumno(a)',
    responsable_nombres: '',
    responsable_apellidos: '',
    responsable_rut: '',
    responsable_dv: '',
    responsable_email: '',
    responsable_parentesco: 'Padre'
  });

  const [loading, setLoading] = useState(false);
  const [valorExtra, setValorExtra] = useState(null);

  /**
   * Carga los datos de la gira cuando se abre el modal
   */
  useEffect(() => {
    const cargarDatosGira = async () => {
      try {
        const resultado = await getGira(giraId);
        console.log('Resultado de getGira:', resultado.gira.pro_valorextra);
        if (resultado && resultado.gira) {
          // Obtener el valor extra del programa
          console.log('Valor extra de la gira:', resultado.gira.pro_valorextra);
          if (resultado.gira.pro_valorextra) {
            console.log('Valor extra de la gira:', resultado.gira.pro_valorextra);
            setValorExtra(resultado.gira.pro_valorextra);
          } else {
            setValorExtra(0);
          }
        }
      } catch (error) {
        console.error('Error al cargar gira:', error);
        setValorExtra(0);
      }
    };

    if (show && giraId) {
      cargarDatosGira();
    }
  }, [show, giraId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validarRUT = (rut, dv) => {
    if (!rut || !dv) return false;
    // Validación básica de RUT
    return rut.trim().length > 0 && dv.trim().length === 1;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validaciones
    if (!formData.alumno_nombres || !formData.alumno_apellidos || !formData.alumno_rut) {
      Swal.fire({
        icon: 'warning',
        title: 'Datos Incompletos',
        text: 'Por favor completa los datos del alumno'
      });
      return;
    }

    if (!formData.responsable_nombres || !formData.responsable_apellidos || !formData.responsable_rut || !formData.responsable_email) {
      Swal.fire({
        icon: 'warning',
        title: 'Datos Incompletos',
        text: 'Por favor completa los datos del responsable'
      });
      return;
    }

    setLoading(true);

    const resultado = await crearSolicitudCupo({
      gir_id: giraId,
      ...formData
    });

    setLoading(false);

    if (!resultado.error) {
      Swal.fire({
        icon: 'success',
        title: 'Solicitud Enviada',
        text: 'Tu solicitud de cupo ha sido registrada. El administrador la revisará pronto.'
      }).then(() => {
        setFormData({
          alumno_nombres: '',
          alumno_apellidos: '',
          alumno_rut: '',
          alumno_dv: '',
          alumno_nacionalidad: '',
          alumno_fecha_nacimiento: '',
          alumno_calidad: 'Alumno(a)',
          responsable_nombres: '',
          responsable_apellidos: '',
          responsable_rut: '',
          responsable_dv: '',
          responsable_email: '',
          responsable_parentesco: 'Padre'
        });
        onHide();
        if (onSuccess) onSuccess();
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: resultado.msg || 'Error al crear solicitud de cupo'
      });
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Solicitar Nuevo Cupo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          {/* Datos del Alumno */}
          <div style={{ marginBottom: '30px' }}>
            <h5 style={{ marginBottom: '15px', color: '#2c3e50', fontWeight: 'bold' }}>
              <i className='material-icons' style={{ fontSize: '1.2rem', verticalAlign: 'middle', marginRight: '8px' }}>person</i>
              Datos del Alumno
            </h5>
            <Form.Group className="mb-3">
              <Form.Label>Nombres *</Form.Label>
              <Form.Control
                type="text"
                name="alumno_nombres"
                value={formData.alumno_nombres}
                onChange={handleInputChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Apellidos *</Form.Label>
              <Form.Control
                type="text"
                name="alumno_apellidos"
                value={formData.alumno_apellidos}
                onChange={handleInputChange}
                required
              />
            </Form.Group>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 100px', gap: '15px' }}>
              <Form.Group className="mb-3">
                <Form.Label>RUT *</Form.Label>
                <Form.Control
                  type="text"
                  name="alumno_rut"
                  value={formData.alumno_rut}
                  onChange={handleInputChange}
                  placeholder="Ej: 12345678"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>DV *</Form.Label>
                <Form.Control
                  type="text"
                  name="alumno_dv"
                  value={formData.alumno_dv}
                  onChange={handleInputChange}
                  maxLength="1"
                  placeholder="Ej: K"
                  required
                />
              </Form.Group>
            </div>

            <Form.Group className="mb-3">
              <Form.Label>Nacionalidad</Form.Label>
              <Form.Control
                type="text"
                name="alumno_nacionalidad"
                value={formData.alumno_nacionalidad}
                onChange={handleInputChange}
                placeholder="Ej: Chilena"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Fecha de Nacimiento</Form.Label>
              <Form.Control
                type="date"
                name="alumno_fecha_nacimiento"
                value={formData.alumno_fecha_nacimiento}
                onChange={handleInputChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Calidad</Form.Label>
              <Form.Select
                name="alumno_calidad"
                value={formData.alumno_calidad}
                onChange={handleInputChange}
              >
                <option value="Alumno(a)">Alumno(a)</option>
                <option value="Apoderado(a)">Apoderado(a)</option>
                <option value="Profesor(a)">Profesor(a)</option>
                <option value="Liberado 100%">Liberado 100%</option>
                <option value="Liberado 50%">Liberado 50%</option>
              </Form.Select>
            </Form.Group>
          </div>

          {/* Datos del Responsable */}
          <div style={{ 
            paddingTop: '20px', 
            borderTop: '2px solid #ddd',
            marginBottom: '20px'
          }}>
            <h5 style={{ marginBottom: '15px', color: '#2c3e50', fontWeight: 'bold' }}>
              <i className='material-icons' style={{ fontSize: '1.2rem', verticalAlign: 'middle', marginRight: '8px' }}>verified_user</i>
              Datos del Responsable
            </h5>

            <Form.Group className="mb-3">
              <Form.Label>Nombres *</Form.Label>
              <Form.Control
                type="text"
                name="responsable_nombres"
                value={formData.responsable_nombres}
                onChange={handleInputChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Apellidos *</Form.Label>
              <Form.Control
                type="text"
                name="responsable_apellidos"
                value={formData.responsable_apellidos}
                onChange={handleInputChange}
                required
              />
            </Form.Group>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 100px', gap: '15px' }}>
              <Form.Group className="mb-3">
                <Form.Label>RUT *</Form.Label>
                <Form.Control
                  type="text"
                  name="responsable_rut"
                  value={formData.responsable_rut}
                  onChange={handleInputChange}
                  placeholder="Ej: 12345678"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>DV *</Form.Label>
                <Form.Control
                  type="text"
                  name="responsable_dv"
                  value={formData.responsable_dv}
                  onChange={handleInputChange}
                  maxLength="1"
                  placeholder="Ej: K"
                  required
                />
              </Form.Group>
            </div>

            <Form.Group className="mb-3">
              <Form.Label>Email *</Form.Label>
              <Form.Control
                type="email"
                name="responsable_email"
                value={formData.responsable_email}
                onChange={handleInputChange}
                placeholder="Ej: correo@ejemplo.com"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Parentesco</Form.Label>
              <Form.Select
                name="responsable_parentesco"
                value={formData.responsable_parentesco}
                onChange={handleInputChange}
              >
                <option value="Abuelo(a)">Abuelo(a)</option>
                <option value="Esposo(a)">Esposo(a)</option>
                <option value="Hermano(a)">Hermano(a)</option>
                <option value="Hijo(a)">Hijo(a)</option>
                <option value="Padre">Padre</option>
                <option value="Madre">Madre</option>
                <option value="Otro">Otro</option>
              </Form.Select>
            </Form.Group>
          </div>

          <div style={{ 
            backgroundColor: '#f0f7ff',
            padding: '15px',
            borderRadius: '4px',
            marginBottom: '20px',
            borderLeft: '4px solid #2196F3'
          }}>
            <p style={{ margin: 0, fontSize: '0.9rem', color: '#1565c0', marginBottom: '8px' }}>
              <i className='material-icons' style={{ fontSize: '1rem', verticalAlign: 'middle', marginRight: '5px' }}>info</i>
              <strong>Nota:</strong> Tu solicitud será revisada por el administrador. Recibirás una notificación cuando sea procesada.
            </p>
            {valorExtra !== null && valorExtra > 0 && (
              <p style={{ margin: 0, fontSize: '0.9rem', color: '#1565c0', marginTop: '10px', paddingTop: '10px', borderTop: '1px solid rgba(21, 101, 192, 0.2)' }}>
                <i className='material-icons' style={{ fontSize: '1rem', verticalAlign: 'middle', marginRight: '5px' }}>attach_money</i>
                <strong>Valor Adicional:</strong> Se sumará ${valorExtra.toLocaleString('es-CL')} a la gira por concepto de cupo extra.
              </p>
            )}
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <ButtonComponent
          variant="secondary"
          className="btn btn-danger"
          onClick={onHide}
          disabled={loading}
        >
          Cancelar
        </ButtonComponent>
        <ButtonComponent
          variant="primary"
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? 'Enviando...' : 'Enviar Solicitud'}
        </ButtonComponent>
      </Modal.Footer>
    </Modal>
  );
}
